import React, { useContext } from "react";
import "./PageEleven.scss";
import { BuildingsContext } from "../../../bContext";

function PageEleven() {
  const { switchToEnglish } = useContext(BuildingsContext);
  return (
    <>
      <div className="pageEleven">
        {/* <div className="menu-pg4"></div> */}

        <div>
          <div className="speech-bubble5">
            {switchToEnglish === false ? (
              <p className="first">
                Aby przejść do kolejnego obiektu, nie musimy zamykać okna.
                Wystarczy że klikniemy w lewo lub prawo.
              </p>
            ) : (
              <p className="first">
                To move to the next object, we don't have to close the window. Just click left or right.
              </p>
            )}
            <div className="inner-triangle-right5"></div>
            <div className="inner-triangle-right6"></div>
          </div>
          {/* <div className="speech-bubble6">
            <p className="first">
              ...natomiast jego nazwa wyświetli się w tym okienku.
            </p>
            <div className="inner-triangle-right6"></div>
          </div> */}
          {/* <div className="menu-pg5"></div>  */}

          <div className="modal-header-ins"></div>
          <div className="modalbtn"></div>
          <div className="defaultbtn"></div>
        </div>
      </div>
    </>
  );
}

export default PageEleven;
